import ProfileModel from "models/profiles/Profile";

export function convertAPIProfileResponseToUserState(data: any): ProfileModel {
	return ProfileModel.generateFromAPI(data);
}

export function convertUserStateToApiRequest(profile: ProfileModel): any {
	return profile.exportToAPIRequest();
}
